import * as LottiePlayer from "@lottiefiles/lottie-player";

import './lottie.scss'

// Full ally logo animated
const defaultSource = "https://assets9.lottiefiles.com/packages/lf20_ekiqpaig.json"

export default function Lottie(props) {

    return (
        <div
            className='lottie-wrapper'
            style={{ height: props.height, width: props.width || 'fit-content' }}
        >
            <lottie-player
                autoplay={props.autoplay || true}
                controls={props.controls}
                loop={props.loop}
                hover={props.hover}
                mode={props.mode || "normal"}
                src={props.src || defaultSource}
                style={{ height: props.height, width: props.width || 'fit-content' }}
            />
        </div>
    );
}